import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask800To899Service {

  constructor() { }
}
